import styled from 'styled-components';

export const WrapperStyled = styled.div`
  margin: 0 auto;
  max-width: 92rem;
  padding-bottom: 18.8rem;
`;
